import { useRegisterSW } from 'virtual:pwa-register/react'
import { RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/button'

/** Controlled PWA updates: a new version is activated only when the user agrees. */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      console.warn('[pwa] registro fallido', error)
    },
  })
  if (!needRefresh) return null
  return (
    <div role="status" className="fixed inset-x-4 bottom-4 z-[60] mx-auto flex max-w-md items-center gap-3 rounded-xl border bg-surface p-4 shadow-lift sm:inset-x-auto sm:right-4">
      <RefreshCw className="size-5 shrink-0 text-primary" aria-hidden />
      <p className="flex-1 text-sm">Hay una nueva versión disponible.</p>
      <Button size="sm" variant="ghost" onClick={() => setNeedRefresh(false)}>
        Luego
      </Button>
      <Button size="sm" onClick={() => updateServiceWorker(true)}>
        Actualizar
      </Button>
    </div>
  )
}
